export default {
  install(app) {
    app.config.globalProperties.$hasPermission = function (permission) {
      const permissions = this.$store.state.identity.permissions;
      if (!Array.isArray(permissions)) {
        return false;
      }

      const [mainPermission] = permission.split('.');
      return permissions.includes(mainPermission) || permissions.includes(permission);
    };
  }
};
